import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import image from 'images/landing/big_photo.jpg';
import Player from '@vimeo/player';


export default class extends Component {
    state = {
        isPlaying : false
    };

    openHandlePlaying = () =>{
        this.setState({isPlaying: true}, () =>  this.player.play() );
    };

    closeHandlePlaying = () =>{
        this.setState({isPlaying: false}, () => { this.player.pause(); this.player.setCurrentTime(0) });
    };

    handleAutoPlayVideo = () => {
        let iframe = document.querySelector('.who-we-are-video');
        this.player = new Player(iframe);

    };

    render() {
        let classes = classNames('section who-are-we justify-content-center',{
            'playing': this.state.isPlaying
        });
        return (
            <section className={classes}>
              <button className="btn close-player ic ic-close-circle" onClick={this.closeHandlePlaying}>
              </button>
              <img src={image} alt="placeholder" className="placeholder"/>
              <div className="section-bg">
                <div className="col-md-8">
                  <h2 className="section-title">Who are We?</h2>
                  <div className="section-subtitle">
                    <p>Dr Paul Ryan,</p>
                    <p>Prescription Revision Founder</p>
                  </div>
                  <div className="button-set">
                    <Link className="btn white bordered rounded" to="/aboutus">More About Us</Link>
                    {/*<button className="btn white bordered rounded">More About Us</button>*/}
                  </div>
                </div>
              </div>
                <iframe src="https://player.vimeo.com/video/240848964"
                        className="who-we-are-video"
                        frameBorder="0"
                        allowFullScreen
                        onLoad={this.handleAutoPlayVideo}
                />
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/landing/components/WhoAreWe.js